// ภาพประกอบ SVG วาดเอง (ธีมมืด ม่วง-ชมพู-ทอง) — เบา ไม่พึ่งไฟล์ภายนอก ตกแต่งอย่างเดียว (aria-hidden)
import React from "react";
import { avatarUri } from "../avatars";

const P = "#8b5cf6", K = "#ec4899", G = "#fbbf24";

/** เติมไล่เฉดม่วง-ชมพู / ทอง ให้แต่ละภาพ (id ไม่ซ้ำต่อภาพ) */
function Defs({ id }) {
  return (
    <defs>
      <linearGradient id={`${id}-g`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor={P} /><stop offset="1" stopColor={K} /></linearGradient>
      <linearGradient id={`${id}-d`} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#2b2545" /><stop offset="1" stopColor="#181427" /></linearGradient>
      <linearGradient id={`${id}-y`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#fde68a" /><stop offset="1" stopColor="#f59e0b" /></linearGradient>
      <radialGradient id={`${id}-o`} cx="50%" cy="50%" r="50%"><stop offset="0" stopColor={P} stopOpacity=".5" /><stop offset="0.6" stopColor={K} stopOpacity=".16" /><stop offset="1" stopColor={K} stopOpacity="0" /></radialGradient>
    </defs>
  );
}

const Spark = ({ x, y, s = 1, c = G, o = 1, cls }) => (
  <path className={cls} transform={`translate(${x} ${y}) scale(${s})`} opacity={o} fill={c} d="M0-10C1.5-4 4-1.5 10 0 4 1.5 1.5 4 0 10-1.5 4-4 1.5-10 0-4-1.5-1.5-4 0-10Z" />
);

function Svg({ id, w, h, className, children, label }) {
  return (
    <svg className={`art ${className || ""}`} viewBox={`0 0 ${w} ${h}`} role="img" aria-hidden={label ? undefined : "true"} aria-label={label} focusable="false">
      <Defs id={id} />
      {children}
    </svg>
  );
}

/** ฮีโรหน้า Landing — ห้องแชทลอยกับตัวละคร 3 ตัว */
export function HeroArt({ className }) {
  const id = "hero";
  const av = ["luna", "fahsai", "phumi"].map(avatarUri);
  return (
    <Svg id={id} w={480} h={340} className={className}>
      <ellipse cx="240" cy="175" rx="230" ry="160" fill={`url(#${id}-o)`} />
      <circle cx="240" cy="170" r="128" fill="none" stroke="rgba(255,255,255,.07)" strokeDasharray="2 8" />
      <circle cx="240" cy="170" r="92" fill="none" stroke="rgba(255,255,255,.06)" />
      <g className="art-float">
        <rect x="86" y="62" width="214" height="78" rx="26" fill={`url(#${id}-d)`} stroke="rgba(255,255,255,.14)" />
        <path d="M118 140l-6 24 28-24z" fill="#231e39" />
        <circle cx="122" cy="101" r="22" fill={`url(#${id}-g)`} />
        <clipPath id={`${id}-c1`}><circle cx="122" cy="101" r="20" /></clipPath>
        <image href={av[0]} x="100" y="80" width="44" height="44" clipPath={`url(#${id}-c1)`} />
        <rect x="156" y="84" width="112" height="10" rx="5" fill="rgba(255,255,255,.55)" />
        <rect x="156" y="104" width="78" height="10" rx="5" fill="rgba(255,255,255,.25)" />
      </g>
      <g className="art-float art-float--2">
        <rect x="176" y="168" width="222" height="70" rx="26" fill={`url(#${id}-g)`} />
        <path d="M372 238l8 22-30-22z" fill={K} />
        <rect x="200" y="190" width="150" height="10" rx="5" fill="rgba(255,255,255,.85)" />
        <rect x="200" y="210" width="96" height="10" rx="5" fill="rgba(255,255,255,.55)" />
      </g>
      <g className="art-float art-float--3">
        <rect x="70" y="214" width="92" height="46" rx="23" fill={`url(#${id}-d)`} stroke="rgba(255,255,255,.14)" />
        <circle cx="100" cy="237" r="5" fill="#b0aac8" /><circle cx="116" cy="237" r="5" fill="#b0aac8" opacity=".7" /><circle cx="132" cy="237" r="5" fill="#b0aac8" opacity=".4" />
      </g>
      {[[400, 90, av[1]], [58, 150, av[2]]].map(([x, y, src], i) => (
        <g key={i} className={`art-float art-float--${i + 2}`}>
          <circle cx={x} cy={y} r="29" fill={`url(#${id}-g)`} />
          <clipPath id={`${id}-c${i + 2}`}><circle cx={x} cy={y} r="26" /></clipPath>
          <image href={src} x={x - 26} y={y - 26} width="52" height="52" clipPath={`url(#${id}-c${i + 2})`} />
        </g>
      ))}
      <g className="art-float art-float--3">
        <circle cx="352" cy="54" r="17" fill={`url(#${id}-y)`} /><circle cx="352" cy="54" r="11" fill="none" stroke="rgba(120,53,15,.35)" strokeWidth="2.5" />
      </g>
      <Spark x={430} y={196} s={1.3} cls="art-twinkle" /><Spark x={36} y={70} s={0.9} c="#c4b5fd" cls="art-twinkle art-twinkle--2" /><Spark x={300} y={300} s={0.8} c="#f9a8d4" cls="art-twinkle" /><Spark x={440} y={290} s={0.6} />
    </Svg>
  );
}

/** หน้า login / register — พระจันทร์เสี้ยว + ดาว + ฟองแชท */
export function AuthArt({ className }) {
  const id = "auth";
  return (
    <Svg id={id} w={240} h={130} className={className}>
      <ellipse cx="120" cy="70" rx="116" ry="60" fill={`url(#${id}-o)`} />
      <path d="M98 22a46 46 0 1 0 38 74A40 40 0 0 1 98 22Z" fill={`url(#${id}-g)`} />
      <g className="art-float"><rect x="132" y="38" width="62" height="34" rx="14" fill={`url(#${id}-d)`} stroke="rgba(255,255,255,.18)" /><circle cx="148" cy="55" r="3.6" fill="#c4b5fd" /><circle cx="163" cy="55" r="3.6" fill="#c4b5fd" opacity=".7" /><circle cx="178" cy="55" r="3.6" fill="#c4b5fd" opacity=".4" /></g>
      <Spark x={60} y={30} s={0.8} cls="art-twinkle" /><Spark x={204} y={26} s={1} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={40} y={96} s={0.6} c="#c4b5fd" /><Spark x={206} y={98} s={0.7} />
    </Svg>
  );
}

const Stage = ({ id, children }) => (
  <>
    <ellipse cx="120" cy="92" rx="112" ry="78" fill={`url(#${id}-o)`} />
    <ellipse cx="120" cy="164" rx="62" ry="8" fill="rgba(0,0,0,.35)" />
    {children}
  </>
);

/** ยังไม่มีแชท / ไม่มีความคิดเห็น */
export function ChatEmptyArt({ className }) {
  const id = "ce";
  return (
    <Svg id={id} w={240} h={176} className={className}>
      <Stage id={id}>
        <g className="art-float">
          <rect x="52" y="34" width="112" height="64" rx="22" fill={`url(#${id}-d)`} stroke="rgba(255,255,255,.16)" />
          <path d="M76 98l-6 20 24-20z" fill="#231e39" />
          <circle cx="86" cy="66" r="5" fill="#c4b5fd" /><circle cx="108" cy="66" r="5" fill="#c4b5fd" opacity=".7" /><circle cx="130" cy="66" r="5" fill="#c4b5fd" opacity=".4" />
        </g>
        <g className="art-float art-float--2">
          <rect x="112" y="84" width="84" height="50" rx="18" fill={`url(#${id}-g)`} />
          <path d="M176 134l6 18-22-18z" fill={K} />
          <path d="M138 108l8 8 16-17" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" opacity=".9" />
        </g>
      </Stage>
      <Spark x={30} y={52} s={0.8} cls="art-twinkle" /><Spark x={206} y={46} s={1} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={214} y={130} s={0.6} c="#c4b5fd" />
    </Svg>
  );
}

/** ไม่พบผลลัพธ์ */
export function SearchEmptyArt({ className }) {
  const id = "se";
  return (
    <Svg id={id} w={240} h={176} className={className}>
      <Stage id={id}>
        <g className="art-float">
          <circle cx="108" cy="82" r="40" fill="rgba(139,92,246,.14)" stroke={`url(#${id}-g)`} strokeWidth="9" />
          <path d="M92 70a22 22 0 0 1 20-10" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="4" strokeLinecap="round" />
          <path d="M138 112l36 36" stroke={`url(#${id}-g)`} strokeWidth="13" strokeLinecap="round" />
          <path d="M96 90q12 -9 24 0" fill="none" stroke="#c4b5fd" strokeWidth="4" strokeLinecap="round" />
          <circle cx="96" cy="76" r="3.5" fill="#c4b5fd" /><circle cx="120" cy="76" r="3.5" fill="#c4b5fd" />
        </g>
      </Stage>
      <Spark x={184} y={44} s={1.2} cls="art-twinkle" /><Spark x={36} y={110} s={0.8} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={206} y={108} s={0.6} c="#c4b5fd" />
    </Svg>
  );
}

/** ไม่มีแจ้งเตือน */
export function BellEmptyArt({ className }) {
  const id = "be";
  return (
    <Svg id={id} w={240} h={176} className={className}>
      <Stage id={id}>
        <g className="art-swing" style={{ transformOrigin: "120px 36px" }}>
          <path d="M120 36c-26 0-42 18-42 44 0 22-6 30-14 40h112c-8-10-14-18-14-40 0-26-16-44-42-44Z" fill={`url(#${id}-g)`} />
          <path d="M96 60c6-8 14-12 24-12" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="5" strokeLinecap="round" />
          <circle cx="120" cy="32" r="7" fill={`url(#${id}-y)`} />
          <path d="M106 128a14 14 0 0 0 28 0Z" fill={`url(#${id}-y)`} />
          <rect x="62" y="116" width="116" height="8" rx="4" fill="#d946ef" opacity=".6" />
        </g>
      </Stage>
      <Spark x={44} y={50} s={0.9} cls="art-twinkle" /><Spark x={200} y={62} s={1.1} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={190} y={134} s={0.6} />
    </Svg>
  );
}

function Coin({ x, y, r = 30, id }) {
  return (
    <g>
      <ellipse cx={x} cy={y + 8} rx={r} ry={r * 0.42} fill="#b45309" />
      <rect x={x - r} y={y} width={r * 2} height="8" fill="#d97706" />
      <ellipse cx={x} cy={y} rx={r} ry={r * 0.42} fill={`url(#${id}-y)`} />
      <ellipse cx={x} cy={y} rx={r * 0.66} ry={r * 0.26} fill="none" stroke="rgba(120,53,15,.35)" strokeWidth="2.5" />
    </g>
  );
}

/** เติมคอยน์ — กองเหรียญ + เหรียญลอย */
export function CoinsArt({ className }) {
  const id = "co";
  return (
    <Svg id={id} w={240} h={176} className={className}>
      <Stage id={id}>
        <Coin id={id} x={86} y={134} /><Coin id={id} x={150} y={128} /><Coin id={id} x={118} y={116} /><Coin id={id} x={118} y={100} />
        <g className="art-float">
          <circle cx="170" cy="56" r="26" fill={`url(#${id}-y)`} /><circle cx="170" cy="56" r="17" fill="none" stroke="rgba(120,53,15,.35)" strokeWidth="3" />
          <path d="M170 46v20M164 52h9a4 4 0 0 1 0 8h-9" fill="none" stroke="rgba(120,53,15,.5)" strokeWidth="3" strokeLinecap="round" />
        </g>
      </Stage>
      <Spark x={52} y={64} s={1} cls="art-twinkle" /><Spark x={212} y={96} s={0.8} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={72} y={30} s={0.6} c="#c4b5fd" />
    </Svg>
  );
}

/** คลับ VIP / อันดับ — มงกุฎ */
export function CrownArt({ className }) {
  const id = "cr";
  return (
    <Svg id={id} w={240} h={176} className={className}>
      <Stage id={id}>
        <g className="art-float">
          <path d="M62 126l-10-62 42 32 26-44 26 44 42-32-10 62Z" fill={`url(#${id}-y)`} stroke="#b45309" strokeWidth="2" strokeLinejoin="round" />
          <rect x="62" y="126" width="116" height="16" rx="6" fill="#d97706" />
          <circle cx="120" cy="108" r="9" fill={`url(#${id}-g)`} /><circle cx="90" cy="118" r="5" fill="#34d399" /><circle cx="150" cy="118" r="5" fill="#38bdf8" />
          <circle cx="52" cy="62" r="6" fill="#fde68a" /><circle cx="120" cy="48" r="6" fill="#fde68a" /><circle cx="188" cy="62" r="6" fill="#fde68a" />
        </g>
      </Stage>
      <Spark x={34} y={48} s={1} cls="art-twinkle" /><Spark x={208} y={40} s={0.9} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={210} y={128} s={0.6} c="#c4b5fd" />
    </Svg>
  );
}

/** รางวัล / ของขวัญ */
export function GiftArt({ className }) {
  const id = "gi";
  return (
    <Svg id={id} w={240} h={176} className={className}>
      <Stage id={id}>
        <g className="art-float">
          <rect x="70" y="84" width="100" height="70" rx="10" fill={`url(#${id}-g)`} />
          <rect x="62" y="64" width="116" height="26" rx="9" fill="#a855f7" />
          <rect x="108" y="64" width="24" height="90" fill={`url(#${id}-y)`} />
          <path d="M120 64c-8-26-38-30-38-14 0 12 22 14 38 14Zm0 0c8-26 38-30 38-14 0 12-22 14-38 14Z" fill="none" stroke={`url(#${id}-y)`} strokeWidth="7" strokeLinejoin="round" />
        </g>
      </Stage>
      <Spark x={40} y={60} s={1} cls="art-twinkle" /><Spark x={204} y={56} s={1.1} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={198} y={132} s={0.7} c="#c4b5fd" />
    </Svg>
  );
}

/** 404 — ดวงจันทร์หลงทาง */
export function NotFoundArt({ className }) {
  const id = "nf";
  return (
    <Svg id={id} w={320} h={200} className={className}>
      <ellipse cx="160" cy="100" rx="150" ry="90" fill={`url(#${id}-o)`} />
      <text x="160" y="118" textAnchor="middle" fontSize="104" fontWeight="800" fill="none" stroke={`url(#${id}-g)`} strokeWidth="3" opacity=".55" fontFamily="system-ui, sans-serif">404</text>
      <g className="art-float">
        <circle cx="160" cy="92" r="52" fill={`url(#${id}-d)`} stroke="rgba(255,255,255,.16)" strokeWidth="2" />
        <circle cx="138" cy="76" r="10" fill="rgba(139,92,246,.35)" /><circle cx="180" cy="106" r="13" fill="rgba(236,72,153,.28)" /><circle cx="150" cy="118" r="6" fill="rgba(139,92,246,.35)" />
        <path d="M132 148c18 10 40 10 58 0" fill="none" stroke={`url(#${id}-g)`} strokeWidth="5" strokeLinecap="round" opacity=".0" />
        <ellipse cx="160" cy="92" rx="84" ry="16" fill="none" stroke={`url(#${id}-y)`} strokeWidth="4" transform="rotate(-18 160 92)" strokeDasharray="120 40" />
      </g>
      <Spark x={46} y={44} s={1.2} cls="art-twinkle" /><Spark x={274} y={60} s={1} c="#f9a8d4" cls="art-twinkle art-twinkle--2" /><Spark x={60} y={150} s={0.8} c="#c4b5fd" /><Spark x={268} y={152} s={0.7} />
    </Svg>
  );
}

/** ตัวเลือกภาพสำหรับ EmptyState (map จากอีโมจิเดิมที่แต่ละหน้าส่งมา) */
export const ART_BY_ICON = {
  "💬": ChatEmptyArt, "🔎": SearchEmptyArt, "🤔": SearchEmptyArt, "🔔": BellEmptyArt, "🧭": NotFoundArt,
  "🎁": GiftArt, "🏆": CrownArt, "🧾": CoinsArt, "🤝": GiftArt,
};
